import { render, staticRenderFns } from "./TireInfoCard.vue?vue&type=template&id=13fae42c&scoped=true"
import script from "./TireInfoCard.vue?vue&type=script&lang=ts"
export * from "./TireInfoCard.vue?vue&type=script&lang=ts"
import style0 from "./TireInfoCard.vue?vue&type=style&index=0&id=13fae42c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fae42c",
  null
  
)

export default component.exports